/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

/**
 * Inline styles keep the assistant usable without a theme pack.
 * Override any of the `ms-commerce-assistant__*` class names from a theme to restyle it.
 */
export const assistantStyles: Record<string, React.CSSProperties> = {
    launcher: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '44px',
        height: '44px',
        padding: 0,
        border: 'none',
        borderRadius: '50%',
        background: '#0078d4',
        color: '#ffffff',
        cursor: 'pointer',
        flex: '0 0 auto'
    },
    panel: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        width: '420px',
        maxWidth: '100vw',
        display: 'flex',
        flexDirection: 'column',
        background: '#faf9f8',
        borderLeft: '1px solid #edebe9',
        boxShadow: '-2px 0 12px rgba(0, 0, 0, 0.12)',
        zIndex: 1000,
        // The host slot (e.g. the header) can set its own colour and alignment, so pin them here.
        color: '#201f1e',
        textAlign: 'left',
        fontFamily: '"Segoe UI", system-ui, -apple-system, sans-serif',
        fontSize: '14px',
        lineHeight: 1.4,
        boxSizing: 'border-box'
    },
    panelHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px',
        borderBottom: '1px solid #edebe9',
        background: '#ffffff',
        color: '#201f1e',
        flex: '0 0 auto'
    },
    panelTitle: {
        margin: 0,
        fontSize: '16px',
        fontWeight: 600,
        color: '#201f1e'
    },
    closeButton: {
        border: 'none',
        background: 'transparent',
        fontSize: '18px',
        lineHeight: 1,
        cursor: 'pointer',
        color: '#201f1e',
        padding: '4px 8px'
    },
    transcript: {
        flex: '1 1 auto',
        overflowY: 'auto',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
    },
    messageUser: {
        alignSelf: 'flex-end',
        maxWidth: '80%',
        padding: '10px 14px',
        borderRadius: '14px 14px 2px 14px',
        background: '#0078d4',
        color: '#ffffff',
        whiteSpace: 'pre-wrap',
        textAlign: 'left'
    },
    messageAssistant: {
        alignSelf: 'flex-start',
        maxWidth: '80%',
        padding: '10px 14px',
        borderRadius: '14px 14px 14px 2px',
        background: '#ffffff',
        border: '1px solid #edebe9',
        whiteSpace: 'pre-wrap',
        color: '#201f1e',
        textAlign: 'left'
    },
    status: {
        alignSelf: 'flex-start',
        fontSize: '13px',
        color: '#605e5c'
    },
    alert: {
        margin: '0 16px 12px',
        padding: '10px 12px',
        borderRadius: '4px',
        background: '#fde7e9',
        color: '#a80000',
        fontSize: '13px'
    },
    composer: {
        display: 'flex',
        gap: '8px',
        padding: '12px 16px',
        borderTop: '1px solid #edebe9',
        background: '#ffffff'
    },
    input: {
        flex: '1 1 auto',
        minWidth: 0,
        padding: '10px 12px',
        border: '1px solid #8a8886',
        borderRadius: '18px',
        fontSize: '14px',
        color: '#201f1e',
        background: '#ffffff'
    },
    sendButton: {
        padding: '10px 18px',
        border: 'none',
        borderRadius: '18px',
        background: '#0078d4',
        color: '#ffffff',
        fontWeight: 600,
        cursor: 'pointer'
    }
};
